export enum ErrorType {
  DropOffError,
  InfoSiteExtrasError,
  ApplyRewardsError,
  RemoveRewardsError,
  PaginationError,
  SortAndFilterError,
  SABSelectionError
}
